module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Sedona and Oak Creek Canyon")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Ack"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("I want to thank Janeen Trevillyan, president of the Sedona Heritage Museum Board, for encouraging me to share my collection of postcards by writing this book and for helping me find valuable research materials. I also want to thank the staff and volunteers at the Sedona Heritage Museum for maintaining excellent archives on the people and places of Sedona and Oak Creek Canyon. Their suggestions and knowledge were essential to my research. Kim Thompson, a friend and longtime resident, shared her memories and helped me with dating the postcard images, and another friend who grew up in Sedona, John Conway, helped me with his knowledge of filmmaking, early photographers, and area place names. I am always grateful for the postcard collectors and postcard dealers I have been privileged to know over the years for their knowledge of how to date and evaluate postcard types and images. As always, this book would not have happened without the kind encouragement of my husband, Mike; our daughters; and many wonderful friends.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All postcards are from my personal collection. For cards that list a publisher, the publisher’s name is noted at the end of the caption as it appears on the postcard. Many of these publishers went by various similar-sounding names over time as studios were bought and sold and companies merged.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Any misconceptions or errors were not the author’s intention.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 75
// module chunks = 0